import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LoanSimulation } from '../eDniModalInterface';

interface LoanSimulationData {
  data: LoanSimulation | null;
}

const initialState: LoanSimulationData = {
  data: null,
};

export const loanSimulationSlice = createSlice({
  name: 'simulation',
  initialState,
  reducers: {
    saveLoanSimulation: (state, action: PayloadAction<LoanSimulation>) => {
      state.data = action.payload;
    },
  },
});

export const { saveLoanSimulation } = loanSimulationSlice.actions;

export default loanSimulationSlice.reducer;
